import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { HttpClient } from "@angular/common/http";
import { BaseService } from './BaseService';
import { IChildFindFollowup } from "../Models/IChildFindFollowup";
import { IChildFindKnownAnswers } from "../Models/IChildFindKnownAnswers";

@Injectable()
export class ChildFindFollowupService extends BaseService {
  _baseUrl: string = "";

  constructor(protected _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(_http);
    this._baseUrl = baseUrl;
  }

  getAllChildFindFollowup(localStudentId: string) {
    return this._http.get(this._baseUrl + "api/ChildFindFollowup/GetChildFindFollowUpList/" + localStudentId)
      .map((response: IChildFindFollowup[]) => response as IChildFindFollowup[])
      .catch(this.errorHandler);
  }

  getChildFindKnownAnswers(localStudentId: string) {
    return this._http.get(this._baseUrl + "api/ChildFindFollowup/GetChildFindKnownAnswers/" + localStudentId)
      .map((response: IChildFindKnownAnswers) => response as IChildFindKnownAnswers)
      .catch(this.errorHandler);
  }

  getChildFindFollowup(id: number) {
    return this._http.get(this._baseUrl + "api/ChildFindFollowup/GetChildFindFollowUp/" + id)
      .map((response: IChildFindFollowup) => response as IChildFindFollowup)
      .catch(this.errorHandler);
  }

  insertUpdateChildFindFollowup(childFindFollowupDetails: IChildFindFollowup) {
    return this._http.post(this._baseUrl + 'api/ChildFindFollowup/InsertUpdateChildFindFollowup', childFindFollowupDetails)
      .map((response: IChildFindFollowup) => response as IChildFindFollowup)
      .catch(this.errorHandler);
  }

  deleteChildFindFollowup(id) {
    return this._http.delete(this._baseUrl + "api/IChildFindFollowup" + id)
      .map((response: IChildFindFollowup) => response as IChildFindFollowup)
      .catch(this.errorHandler)
  }

  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }
}



